import {
    IconA,
    IconB,
    IconC,
    IconD,
    IconE,
    IconF,
    IconI,
    IconH,
    IconJ,
    IconK,
    IconL,
} from 'elem/compPage/stream-series-plug-in-solar-battery/pages/product/components/PathToZero/Svg';
import IconAc from './IconAc';
import IconDryer from './IconDryer';
import IconMicrowave from './IconMicrowave';

export const getIconList = (locale: string, tab: 'a' | 'b' | 'c') => {
    if (tab === 'a') {
        return [
            {
                name: 'Frige',
                icon: IconA,
            },
            {
                name: 'TV',
                icon: IconD,
            },
            {
                name: 'Wifi',
                icon: IconB,
            },
            {
                name: 'Audio',
                icon: IconC,
            },
            {
                name: 'Dryer',
                icon: IconF,
            },
            {
                name: 'Washing machine',
                icon: IconE,
            },
        ];
    }
    if (tab === 'b') {
        return [
            {
                name: 'AC',
                icon: IconAc,
            },
            {
                name: 'Microwave',
                icon: IconMicrowave,
            },
            {
                name: 'Hair Dryer',
                icon: IconDryer,
            },
        ];
    }
    return [];
};
